import { savingsPeriod, savingsSite } from '../data/state.js';
import { savingsPeriodDays } from './savings-period.js';

/** Download URL for the selected Stats period, site, and export format. */
export function savingsExportHref(orgId: string, format: 'pdf' | 'xlsx'): string {
  const params = new URLSearchParams({ format, period: savingsPeriod.value });
  const days = savingsPeriodDays(savingsPeriod.value);
  if (days > 0) params.set('from', new Date(Date.now() - days * 86_400_000).toISOString());
  if (savingsSite.value !== '') params.set('site', savingsSite.value);
  return `/api/orgs/${orgId}/savings/export?${params.toString()}`;
}
